import { ProjectStatus } from 'consts/statuses';

export const PROJECT_TABS = {
  TEST_EDIT: 'test & edit',
  COLLECT_DATA: 'collect data',
  PROGRESS: 'progress',
  REPORTS: 'reports',
  FILES: 'files',
  SUBSCRIPTIONS: 'subscriptions',
};

type StatusType = {
  value: number;
  display: string;
};

interface Values {
  isAdmin: boolean;
  projectStatus?: StatusType;
  tabName: string;
  isException?: boolean;
}

type TabType = {
  name: string;
  admin: boolean;
  user: boolean;
};

interface SchemaType {
  status: number;
  tabs: TabType[];
}

const schema: Array<SchemaType> = [
  {
    status: ProjectStatus.OFFER_DRAFT,
    tabs: [
      {
        name: PROJECT_TABS.TEST_EDIT,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.COLLECT_DATA,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.PROGRESS,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.REPORTS,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.FILES,
        admin: true,
        user: false,
      },
      {
        name: PROJECT_TABS.SUBSCRIPTIONS,
        admin: false,
        user: false,
      },
    ],
  },
  {
    status: ProjectStatus.OFFER_ACCEPTED,
    tabs: [
      {
        name: PROJECT_TABS.TEST_EDIT,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.COLLECT_DATA,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.PROGRESS,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.REPORTS,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.FILES,
        admin: true,
        user: false,
      },
      {
        name: PROJECT_TABS.SUBSCRIPTIONS,
        admin: false,
        user: false,
      },
    ],
  },
  {
    status: ProjectStatus.COLLECTING_DATA,
    tabs: [
      {
        name: PROJECT_TABS.TEST_EDIT,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.COLLECT_DATA,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.PROGRESS,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.REPORTS,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.FILES,
        admin: true,
        user: false,
      },
      {
        name: PROJECT_TABS.SUBSCRIPTIONS,
        admin: true,
        user: true,
      },
    ],
  },
  {
    status: ProjectStatus.OFFER_ARCHIVED,
    tabs: [
      {
        name: PROJECT_TABS.TEST_EDIT,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.COLLECT_DATA,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.PROGRESS,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.REPORTS,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.FILES,
        admin: true,
        user: false,
      },
      {
        name: PROJECT_TABS.SUBSCRIPTIONS,
        admin: true,
        user: false,
      },
    ],
  },
  {
    status: ProjectStatus.FINISHED,
    tabs: [
      {
        name: PROJECT_TABS.TEST_EDIT,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.COLLECT_DATA,
        admin: false,
        user: false,
      },
      {
        name: PROJECT_TABS.PROGRESS,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.REPORTS,
        admin: true,
        user: true,
      },
      {
        name: PROJECT_TABS.FILES,
        admin: true,
        user: false,
      },
      {
        name: PROJECT_TABS.SUBSCRIPTIONS,
        admin: true,
        user: true,
      },
    ],
  },
];

export const checkAuthorize = ({
  isAdmin,
  projectStatus,
  tabName,
  isException,
}: Values) => {
  if (isException) {
    return false;
  }
  const filterByStatus = schema.find(
    (schemaOption: SchemaType) => schemaOption.status === projectStatus?.value
  );
  const filterByTabName = filterByStatus?.tabs.find(
    (tab: TabType) => tab.name === tabName
  );

  if (filterByTabName) {
    if (isAdmin) return filterByTabName.admin;
    return !!filterByTabName.user;
  }

  return true;
};
